import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 24, className = "" }) {
    return (
        <motion.div
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export function Stagger({ children, className = "", stagger = 0.08 }) {
    return (
        <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.15 }}
            variants={{ show: { transition: { staggerChildren: stagger } } }}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export function Item({ children, className = "", y = 20 }) {
    return (
        <motion.div
            variants={{
                hidden: { opacity: 0, y },
                show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
            }}
            className={className}
        >
            {children}
        </motion.div>
    );
}
